<template>
    <div class="version-info-root">
        Powered by Routematch © {{date.getFullYear()}} | Version {{packageVersion}}
    </div>
</template>

<script>
export default {
  data: () => ({
    date: new Date(),
    config: null,
    // eslint-disable-next-line
    packageVersion: require('../../package.json').version,
  }),
  name: 'Root',
};
</script>

<style>
.version-info-root {
    float: left top;
    position: absolute;
    top: 0;
    z-index: -1;
    color: black;
}
</style>
